var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8853 11.993L22.7771 7.10133C24.3891 5.48929 24.3891 2.82108 22.7771 1.20903C21.165 -0.403011 18.4968 -0.403011 16.8848 1.20903L11.993 6.10075L7.10133 1.20903C5.48928 -0.403011 2.82108 -0.403011 1.20903 1.20903C-0.403011 2.82108 -0.403011 5.48929 1.20903 7.10133L6.10075 11.993L1.20903 16.8848C-0.403011 18.4968 -0.403011 21.165 1.20903 22.7771C2.04285 23.6109 3.09901 24 4.15518 24C5.21135 24 6.26751 23.6109 7.10133 22.7771L11.993 17.8853L16.8848 22.7771C17.7186 23.6109 18.7747 24 19.8309 24C20.8871 24 21.9432 23.6109 22.7771 22.7771C24.3891 21.165 24.3891 18.4968 22.7771 16.8848L17.8853 11.993Z",
    fill: "#9D9DAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseVector);
export default __webpack_public_path__ + "static/media/closeVector.19917ebe8034177f4eba191776d08f1c.svg";
export { ForwardRef as ReactComponent };